// 使其可以没有import的条件下全局引用
// 遍历这个目录下的所有svg
// @ts-ignore
const requireAll = requireContext => requireContext.keys().forEach(requireContext)
const req = require.context('@/assets/svg', true, /\.svg$/)
requireAll(req)
